import { reducerWrapper } from '../../support/utils';

import { EMAIL_PROVIDER_BLUEPRINT } from '../../actions/EmailOnboarding/EmailProviderBlueprint';

const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
};

function Handler(state, action) {
  switch (action.type) {
    case EMAIL_PROVIDER_BLUEPRINT.response:
      return Object.assign({}, state, {
        loading: false,
        error: null,
        data: action.data,
      });

    default:
      return state;
  }
}

const EmailProviderBlueprint = reducerWrapper(INIT_STATE, Handler, {
  request: [EMAIL_PROVIDER_BLUEPRINT],
  error: [EMAIL_PROVIDER_BLUEPRINT],
});

export default EmailProviderBlueprint;
